import { Box, HStack, useColorModeValue } from "@chakra-ui/react";
import CDS from "design-system";
import CaminoAlertIcon from "components/Icon/CaminoAlertIcon";
import { Meeting } from "features/Resources/Meeting/models";
import { titleize } from "helpers/string";

export default function SchedulingWarnings({ meeting }: { meeting: Meeting }) {
  const textColor = useColorModeValue("cdsGrey.800", "cdsGrey.500");
  const borderColor = useColorModeValue("gray.200", "white");
  const unavailableCalendars = meeting.attendees.filter((attendee) => attendee.isExternal).map((attendee) => attendee.emailAddress);
  const unresolvedRoles = meeting.attendees.filter((attendee) => !attendee.userId && attendee.role).map((attendee) => titleize(attendee.role));

  const warnings = [];

  if (unresolvedRoles.length > 0) {
    warnings.push(`No ${unresolvedRoles.join(", ")} assigned`);
  }

  if (unavailableCalendars.length > 0) {
    warnings.push(`Unavailable calendars: ${unavailableCalendars.join(", ")}`);
  }

  if (warnings.length === 0) return null;

  return (
    <Box
      p="6px 8px"
      borderWidth={1}
      borderColor={borderColor}
      borderRadius="md"
    >
      <HStack spacing={2} alignItems="center">
        <CaminoAlertIcon color="red.600" />
        <CDS.Text12 color={textColor}>
          {warnings.join(" | ")}
          <CDS.Text10 fontStyle="italic" fontSize="2xs" as="span">
            {"  (Note: You can still schedule the meeting to block time.)"}
          </CDS.Text10>
        </CDS.Text12>
      </HStack>
    </Box>
  );
}
